module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-09.57c091a3.png";